// Node.js polyfills for libraries like pcb-stackup
import { Buffer } from 'buffer';
import process from 'process';
globalThis.Buffer = Buffer;
globalThis.process = process;

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './pages/landing/styles/landing.css';
import './i18n';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);